import { t } from '@ticarishift/i18n';
import { cn } from '../lib/cn.ts';
import { MARK_GLYPH } from './mark.ts';

type WordmarkProps = {
  /** `mark`: yalnız işaret (dar alanlar, favicon benzeri). */
  variant?: 'full' | 'mark';
  /** Piksel yükseklik; genişlik orantılıdır. */
  height?: number;
  className?: string;
};

/**
 * Geçici kelime logosu (SK-07, SA-11 gelene kadar): işaret ve "TicariShift". Renkler tema token'larından
 * gelir; açık ve koyu temada kendiliğinden uyar.
 */
export function Wordmark({ variant = 'full', height = 28, className }: WordmarkProps) {
  const name = t('common.appName');
  const width = variant === 'full' ? 156 : 32;
  return (
    <svg
      role="img"
      aria-label={name}
      viewBox={`0 0 ${width} 32`}
      height={height}
      width={(height / 32) * width}
      overflow="visible"
      className={cn('shrink-0', className)}
    >
      <rect width="32" height="32" rx="8" className="fill-primary" />
      <path d={MARK_GLYPH} fill="none" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" className="stroke-primary-fg" />
      {variant === 'full' && (
        <text x="42" y="22.5" fontSize="19" fontWeight={650} letterSpacing="-0.2" className="fill-fg font-sans" aria-hidden>
          {name}
        </text>
      )}
    </svg>
  );
}
